import { render } from "./HomeworkEditView.vue?vue&type=template&id=3f39e0e9"
import script from "./HomeworkEditView.vue?vue&type=script&lang=js"
export * from "./HomeworkEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__